import React, { Component } from 'react'
import { string, number, oneOfType } from 'prop-types'
import { translate } from 'react-i18next'
import { Text, PanelCircuit } from 'components'
import './SectionPanels.css'

@translate()
export class SectionPreRaceCircuitPanel extends Component {
    static propTypes = {
        season: number.isRequired,
        race: number.isRequired,
        totalRaces: number.isRequired,
        name: string.isRequired,
        laps: number.isRequired,
        lapLength: number.isRequired,
        temperature: number.isRequired,
        humidity: number.isRequired
    }
    static defaultProps = {
        season: 0,
        race: 0,
        laps: 0,
        lapLength: 0,
        temperature: 0,
        humidity: 0
    }

    render() {
        const { season, race, name, t, ...circuitProps } = this.props
        return (
            <section className="Panels">
                <div className="flex-grow flex col-center">
                    <Text className="Panels-Title" dangerouslySetInnerHTML={{ __html: t('game.PRE_RACE.circuit.title', { season, race, name }) }} />
                    <PanelCircuit season={season} race={race} {...circuitProps} />
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Panels/SectionPreRaceCircuitPanel.js